import { RESET_LINK } from "../../../constants/reducer_names";
import { createSlice } from "@reduxjs/toolkit";
import { resendResetLink } from "../../api/authentication";

const initialState = {
  isLoading: false,
  error: {
    hasError: false,
    errorMessage: "",
  },
};
const resetLinkSlice = createSlice({
  name: RESET_LINK,
  initialState,
  reducers: { reset: () => {} },
  extraReducers: (builder) => {
    builder.addCase(resendResetLink.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(resendResetLink.fulfilled, (state, { payload }) => {
      if (payload?.data?.statusCode !== 200) {
        state.error.hasError = true;
        state.error.errorMessage = payload?.data?.message;
      }
      state.isLoading = false;
    });
    builder.addCase(resendResetLink.rejected, (state, { payload }: any) => {
      state.error.hasError = true;
      state.error.errorMessage = payload?.data?.message;
      state.isLoading = false;
    });
  },
});
export const ResetLinkActions = resetLinkSlice.actions;
export default resetLinkSlice.reducer;
